import { SiteGeometryStore, siteGeometryStore } from "../store";

export const updateSiteFeatures = (features: SiteGeometryStore["siteFeatures"]) => {
  siteGeometryStore.siteFeatures = features;
};
